/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import BidCyclesIcon from 'icons/BidCyclesIcon';

const messages = defineMessages({
  title: {id: 'navigation.instructional-materials.bid-cycles'},
});

const BidCyclesItem = () => (
  <RouteLinkItem
    iconBefore={BidCyclesIcon}
    route="midas/instructional-materials/bid-cycles"
    title={messages.title}
  />
);

export default BidCyclesItem;
